import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

import Fields from "components/ui/Fields";
import { FieldWrap } from "components/styled/Field";
import AddNewItem from "components/styled/AddNewItem";
import { TextButton } from "../Button";
import { midGray } from "utils/constants/colors";

const Wrapper = styled.div`
  max-width: 476px;

  // the add new button
  > div:last-child {
    margin: 4px 0;
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-grow: 1;
  max-width: 428px;

  > ${FieldWrap} {
    margin-right: 5px;

    :last-child {
      margin-right: 0;
    }
  }
`;

const InputsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;

  ${FieldWrap} {
    margin-top: 0;
    margin-bottom: 3px;
  }

  svg {
    color: ${midGray};
    font-size: 18px;
    margin-left: 4px;
    margin-top: 10px;
  }
`;

function MultipleKeyValuePairs({
  name,
  value = [{ key: "", value: "" }],
  onChange,
  onRowRemove,
  addNewButtonTitle,
  KeyComponent = Fields.Input,
  ValueComponent = Fields.Input,
}) {
  const { t } = useTranslation();

  const keyDuplicates = value.filter((obj, index, self) =>
    self.some((o, selfIndex) => index !== selfIndex && o.key === obj.key)
  );

  const onAdd = () => onChange([...value, { key: "", value: "" }]);

  const onRemove = (index) => {
    if (onRowRemove) {
      onRowRemove(index);
      return;
    }

    const newValue = [...value];
    newValue.splice(index, 1);
    onChange(newValue);

    if (newValue.length === 0) {
      onChange([{ key: "", value: "" }]);
    }
  };

  return (
    <Wrapper>
      {value.map((_, index) => {
        const keyInputName = `${name}.${index}.key`;
        const valueInputName = `${name}.${index}.value`;

        return (
          <InputsWrapper key={index}>
            <InputContainer>
              <KeyComponent
                name={keyInputName}
                data-qa={keyInputName}
                placeholder={t("Key")}
              />
              <ValueComponent
                placeholder={t("Value")}
                name={valueInputName}
                data-qa={valueInputName}
              />
            </InputContainer>
            <TextButton onClick={onRemove.bind(null, index)}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </TextButton>
          </InputsWrapper>
        );
      })}
      <AddNewItem disabled={keyDuplicates.length > 0} onClick={onAdd}>
        {addNewButtonTitle ||
          t("Add new {{ entity }}", {
            entity: name.substring(0, name.length - 1),
          })}
      </AddNewItem>
    </Wrapper>
  );
}

export default MultipleKeyValuePairs;
